import React, { useState } from 'react';
import { Input, Button } from 'antd';
import { dummySearchResponse } from '../dummySearchResponse'
import { dummyCitationResponse } from '../dummyCitationResponse'
import Cite from 'citation-js'
import axios from 'axios'
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { CopyOutlined } from "@ant-design/icons";

const { TextArea } = Input;


export const GeneratedText = ({ generatedText, setGeneratedText, currentCaretPosition, setCurrentCaretPosition, references, setReferences, serpSearchResponse, refrencesLoading, generateReferences }) => {
  // const [references, setReferences] = useState({
  //   'sWzmct-yYzgJ': { bibliography: '<div data-csl-entry-id="Fan2014-ww" class="csl-entry">Fan, J., Han, F., &amp; Liu, H. (2014). Challenges of Big Data analysis. <i>Natl. Sci. Rev.</i>, <i>1</i>(2), 293–314.</div>', citation: '(Fan et al., 2014)'},
  //   'sWzmct-yYzg1': { bibliography: '<div data-csl-entry-id="Fan2014-ww" class="csl-entry">Fan, J., Han, F., &amp; Liu, H. (2014). Challenges of Big Data analysis. <i>Natl. Sci. Rev.</i>, <i>1</i>(2), 293–314.</div>', citation: '(Fan et al., 2014)'},
  //   'sWzmct-yYzg2': { bibliography: '<div data-csl-entry-id="Fan2014-ww" class="csl-entry">Fan, J., Han, F., &amp; Liu, H. (2014). Challenges of Big Data analysis. <i>Natl. Sci. Rev.</i>, <i>1</i>(2), 293–314.</div>', citation: '(Fan et al., 2014)'},
  //   'sWzmct-yYzg3': { bibliography: '<div data-csl-entry-id="Fan2014-ww" class="csl-entry">Fan, J., Han, F., &amp; Liu, H. (2014). Challenges of Big Data analysis. <i>Natl. Sci. Rev.</i>, <i>1</i>(2), 293–314.</div>', citation: '(Fan et al., 2014)'},
  //   'sWzmct-yYzg4': { bibliography: '<div data-csl-entry-id="Fan2014-ww" class="csl-entry">Fan, J., Han, F., &amp; Liu, H. (2014). Challenges of Big Data analysis. <i>Natl. Sci. Rev.</i>, <i>1</i>(2), 293–314.</div>', citation: '(Fan et al., 2014)'},
  // });
  const [citationLoading, setCitationLoading] = useState(false);
  const [areReferencesLoaded, setAreReferencesLoaded] = useState(false);

  const handleTextAreaChange = (e) => {
    e.target.style.height = "";
    e.target.style.height = e.target.scrollHeight + "px";
    setGeneratedText(e.target.value);
    checkCaret();
  }

  const checkCaret = (e) => {
    const textarea = document.querySelector('.generated-text-result-textarea textarea');
    if(!textarea)
      setCurrentCaretPosition(0);
    const newPos = textarea.selectionStart;
    if (newPos !== currentCaretPosition) {
      setCurrentCaretPosition(newPos);
    }
  }

  const addCitation = async (result_id) => {
    // setCitationLoading(true);
    let ref = references.find(r => r.result_id === result_id);
    if(!ref) {
      ref = await addReference(result_id);
    }
    if (currentCaretPosition === null) {
      setGeneratedText(`${generatedText} ${ref?.citation}`)
    } else {
      setGeneratedText(`${generatedText.substring(0, currentCaretPosition)} ${ref?.citation} ${generatedText.substring(currentCaretPosition)}`)
    }
  }

  const addReference = async (result_id) => {
    let ref = references.find(r => r.result_id === result_id);
    if(ref) {
      // do nothing
      return ref;
    }
    setCitationLoading(true);

    // fetch citation
    let output;
    try {
      const citationRes = await axios.get(`https://auto-apa-backend-test-1-a3v4rktvya-uc.a.run.app/utility/google-scholar-cite?${new URLSearchParams({
          q: result_id,
      }).toString()}`,);
      const apa = citationRes?.data?.citations.find(c => c.title === 'APA')?.snippet
      let bibTexRes;
      try {
        throw 'err'
        // bibTexRes = await axios.post(
        //     `https://auto-apa-backend-test-1-a3v4rktvya-uc.a.run.app/utility/apa-to-bibtex`,
        //     { apa },
        //     {
        //         headers: { 'Content-Type': 'application/json' },
        //     },
        //     );
        // output = bibTexRes.data.output.split('\n\n')[0]?.toString();
      } catch(error) {
        const bibTexLink = citationRes?.data?.links.find(l => l.name === 'BibTeX')?.link;
        bibTexRes = await axios.get(`https://auto-apa-backend-test-1-a3v4rktvya-uc.a.run.app/utility/get-url?url=${encodeURIComponent(bibTexLink)}`,
        {
            headers: { 'Content-Type': 'application/json' },
        });
        output = bibTexRes.data;
      }
      // const citationRes = await axios.get(`https://auto-apa-backend-auth-a3v4rktvya-uc.a.run.app/utility/google-scholar-cite?${new URLSearchParams({
      //     q: result_id,
      // }).toString()}`,
      // { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` } });
      // const apa = citationRes?.data?.citations.find(c => c.title === 'APA')?.snippet
      // let bibTexRes;
      // try {
      //   throw 'Error'
      //   // bibTexRes = await axios.post(
      //   //     `https://auto-apa-backend-auth-a3v4rktvya-uc.a.run.app/utility/apa-to-bibtex`,
      //   //     { apa },
      //   //     {
      //   //         headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` },
      //   //     },
      //   //     );
      //   // output = bibTexRes.data.output.split('\n\n')[0]?.toString();
      // } catch(error) {
      //   const bibTexLink = citationRes?.data?.links.find(l => l.name === 'BibTeX')?.link;
      //   bibTexRes = await axios.get(`https://auto-apa-backend-auth-a3v4rktvya-uc.a.run.app/utility/get-url?url=${encodeURIComponent(bibTexLink)}`,
      //   {
      //       headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` },
      //   });
      //   output = bibTexRes.data;
      // }
    } catch (error) {
        console.error(error);
        setCitationLoading(false);
        return;
    }
  
    // TODO fetch
    // const referenceObj = dummyCitationResponse.citations.find(c => c.title === 'APA');
    // const plainReference = referenceObj?.snippet;

    // get bibtex
    // TODO call autoAPA api, CORS
    // const res = await axios.post(`https://api.paperpile.com/api/public/convert`, {
    //     fromIds: false,
    //     input: plainReference,
    //     targetFormat: 'Bibtex',
    // });
    // const data = await res.data;

    // extract citation

    // const data = {
    //   output:
    //     '@ARTICLE{Fan2014-ww,\n  title     = "Challenges of Big Data analysis",\n  author    = "Fan, Jianqing and Han, Fang and Liu, Han",\n  abstract  = "Big Data bring new opportunities to modern society and\n               challenges to data scientists. On one hand, Big Data hold great\n               promises for discovering subtle population patterns and\n               heterogeneities that are not possible with small-scale data. On\n               the other hand, the massive sample size and high dimensionality\n               of Big Data introduce unique computational and statistical\n               challenges, including scalability and storage bottleneck, noise\n               accumulation, spurious correlation, incidental endogeneity, and\n               measurement errors. These challenges are distinguished and\n               require new computational and statistical paradigm. This article\n               gives overviews on the salient features of Big Data and how\n               these features impact on paradigm change on statistical and\n               computational methods as well as computing architectures. We\n               also provide various new perspectives on the Big Data analysis\n               and computation. In particular, we emphasize on the viability of\n               the sparsest solution in high-confidence set and point out that\n               exogeneous assumptions in most statistical methods for Big Data\n               can not be validated due to incidental endogeneity. They can\n               lead to wrong statistical inferences and consequently wrong\n               scientific conclusions.",\n  journal   = "Natl. Sci. Rev.",\n  publisher = "Oxford University Press (OUP)",\n  volume    =  1,\n  number    =  2,\n  pages     = "293--314",\n  month     =  jun,\n  year      =  2014,\n  keywords  = "Big Data; data storage; high dimensional data; incidental\n               endogeneity; large-scale optimization; massive data; massively\n               parallel data processing; noise accumulation; random projection;\n               scalability; spurious correlation",\n  copyright = "http://creativecommons.org/licenses/by/4.0/",\n  language  = "en"\n}\n',
    //   token: '2251b287-f774-4629-8d59-231f584517b2',
    //   tags: ['arXiv'],
    //   withErrors: false,
    // };
    
    const cite = new Cite(output);
    
    const citation = cite.format('citation', {
      format: 'html',
      lang: 'en-US',
      template: 'apa',
    });
    
    const bibliography = cite.format('bibliography', {
      format: 'html',
      lang: 'en-US',
      template: 'apa',
    });

    ref = {result_id: result_id, bibliography, citation};
    setCitationLoading(false);
    setReferences((prev) => [...prev, ref]);
    return ref;
  }
  const handleCopy = () => {
    alert("Text copied to clipboard!");
  };

  return(
  <div className='generated-text-container'>
    <div className='generated-text-result-textarea'>
    <div style={{ flex: "1", position: "relative" }}>
        <textarea 
          name="generated-text" 
          id="generated-text" 
          className='thin-scrollbar'
          value={generatedText}
          onInput={handleTextAreaChange}
          onKeyPress={checkCaret}
          onMouseDown={checkCaret}
          onTouchStart={checkCaret}
          onPaste={checkCaret}
          onCut={checkCaret}
          onMouseMove={checkCaret}
          onSelect={checkCaret}
          // onSelectStart={checkCaret}
        >
        </textarea>
        <CopyToClipboard text={generatedText} onCopy={handleCopy} style={{ right: "0", bottom: "0", position: "absolute", margin: "8px" }}>
          <CopyOutlined />
        </CopyToClipboard>
      </div>
      <div className="refrences-list thin-scrollbar">
        <h1 className="references-list-heading">References</h1>
        {citationLoading ? 
          <div style={{ zIndex: "10",  textAlign: "center", position: "relative" }}>
            <Loader type="TailSpin" color="#4FA8DC" height={50} width={50} />{" "}
          </div>
          : 
          <>
            {references?.length > 0 && references.map(ref => <div key={ref.result_id} dangerouslySetInnerHTML={{__html: ref.bibliography}} />)}
          </>
        }
      </div>
    </div>
    <div className="references-section thin-scrollbar">
      <h1 className="references-heading">References</h1>
      {!areReferencesLoaded ? 
      (<Button
                style={{
                  margin: "0px 20px",
                  background: "#4FA8DC",
                  borderRadius: "10px",
                }}
                size="large"
                type="primary"
                shape="round"
                disabled={refrencesLoading}
                loading={refrencesLoading}
                onClick={() => generateReferences(setAreReferencesLoaded)}
              >
                Get References
              </Button>) :
      (refrencesLoading ? 
          <div style={{ zIndex: "10",  textAlign: "center", position: "relative" }}>
            <Loader type="TailSpin" color="#4FA8DC" height={100} width={100} />{" "}
          </div>
          : 
          <>
          {serpSearchResponse?.organic_results.slice(0, 10).map((ref) => {
            const { snippet, link, result_id, title } = ref;
            return <div className="reference-card" key={result_id}>
              <div className="title-row">
                <a className="source-name" href={link} target='_blank'>{title}</a>
                {/* <button className="add-citation-button" onClick={() => addCitation(ref?.result_id)}> 
                  + Add Citation
                </button> */}
                <button className="add-citation-button" onClick={() => addReference(ref?.result_id)}>
                  + Add Reference
                </button>
              </div>
              <div className="reference-body">
                {snippet}
              </div>
            </div>
          })}
          </>
        )}      
    </div>
  </div>
)};
